import React, { useEffect, useMemo, useState } from 'react'
import { formFields, planStatusOptions, planTypeOptions, offerOptions, autoRenewOptions, displaySupportedOptions, durationOptions, spendLimitOptions, editCasePlanStatusOption } from './constant';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import BreadCrumb from '../../../../components/BreadCrumb';
import Datepicker from '../../../../components/FormElements/Datepicker';
import SelectNew from '../../../../components/FormElements/SelectNew'
import { handleError, handleFieldError, initializeForm } from '../../../../utils/form-validation';
import { Link, withRouter } from 'react-router-dom';
import routes from '../../../../routes';
import { configAttributeAction, getAllCountryAction, getAllCurrencyAction, getListByIDSubscriptionPlanAction, getSularCountryListAction, getTenantAction, postAddSubscriptionPlanManagerAction, postListAllSubscriptionPlanMgrAction, postUpdateSubscriptionPlanManagerAction } from '../../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import ToastModal from "../../../../components/ToastModal";
import moment from 'moment';
import { flatMap, get } from 'lodash'
import { getCurrentDateInTimeZone, getDateFromUtcToSpecificZone, getTenantTimeZone, getUserSelectedDateInUtc } from '../../../../selectors';
import { reduxDrawerAction } from '../../../../actions/campaign';
import { infoKeys } from '../../../../helpers/config/infomateryKeys';
import { useFetchInfomateryData } from '../../../../hooks/useFetchInfomateryData';




const Card = asyncRoute(() => import('../../../../components/Card'));
const Input = asyncRoute(() => import('../../../../components/FormElements/Input'))


function EditSubscriptionPlanMgr(props) {

    const reduxInfoData = useFetchInfomateryData();

    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const [tenantListOption, setTenantListOption] = useState([])
    const [countryListOptions, setCountryListOptions] = useState([])
    const [currencyListOptions, setCurrencyListOptions] = useState([])
    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });
    const [editCaseData, setEditCaseData] = useState({})
    const [renewPlanOption, setRenewPlanOption] = useState([])
    const [isDisabledStartDate, setIsDisabledStartDate] = useState(false)
    const [isDisabledEndDate, setIsDisabledEndDate] = useState(false)
    const [durationOptionsList, setDurationUptionsList] = useState([])
    const [currentDate, setCurrentDate] = useState(new Date());
    const [subscriptionInfoData, setSubscriptionInfoData] = useState({})


    const tenantId = useSelector((state) => get(state, 'app.preSignInState.tenantId', ''));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const dispatch = useDispatch();

    const targetTimeZone = getTenantTimeZone(tenantId);



    useEffect(() => {
        if (
          reduxInfoData &&
          !Object.keys(subscriptionInfoData).length > 0
        ) {
          if (
            reduxInfoData.subscriptionPlanScreen &&
            !Object.keys(subscriptionInfoData).length > 0
          ) {
            setSubscriptionInfoData(
              reduxInfoData.subscriptionPlanScreen
            );
          }
        }
      }, [reduxInfoData]);


    useEffect(() => {
        if(targetTimeZone){
        formInitialize();
        daysDuration();
        getTenantList();
        getCountryList();
        getCurrencyList();
        getListALLData();
        }

    }, [targetTimeZone])




    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });
        handleSubmit();
    };


    const formInitialize = () => {
        let { form, errors } = initializeForm(formFields);
        // form.countrySupported = "null";
        // form.offer = "0";
        // formFields.offerValue.required = false
        // formFields.durationLimit.required = true;
        // form.status = "2"
        // form.spendLimit = "0"
        // formFields.spendLimitValue.required = false;
        setForm(form)
    };

    const daysDuration = async () => {
        // let params = "PLAN_DURATION"

        await dispatch(configAttributeAction({ tenantId, authToken, userId, type: 'PLAN_DURATION' }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    // setTimeAttribute(responseList);
                    const listData = responseList.map((ele) => {
                        return {
                            id: ele.key, value: ele.value
                        }
                    })
                    setDurationUptionsList(listData)
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });


    }

    const getListALLData = async () => {
        const { match: { params: { id } } } = props;

        // const payload = {
        //     planType: null,
        //     countrySupported: null,
        //     currencySupported: null
        // }

        await dispatch(getListByIDSubscriptionPlanAction({ tenantId, authToken, userId, id }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    // if (id) {
                    // const listByID = response.find((data) => data.id == id)
                    getEditIdData(response[0])
                    // }

                    // setFeeSettingsListAllData(response)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const getEditIdData = (data) => {

        const formattedStartDate = moment(
            getDateFromUtcToSpecificZone({
              date: data.startDate,
              targetTimeZone,
            })
          ).toDate();

        const formattedEndDate = data.endDate ? moment(
            getDateFromUtcToSpecificZone({
              date: data.endDate,
              targetTimeZone,
            })
          ).toDate() : "";

        form.planName = data.name
        form.planDisplayName = data.displayName
        form.startDate = data.startDate ? formattedStartDate:""
        form.endDate = data.endDate  ? formattedEndDate: ''
        form.planType = data.planType
        form.amountCharges = data.cost
        form.tenantSupported = data.tenantSupported == 0 ? '' : data.tenantSupported
        form.offer = data.offerType
        form.offerValue = data.offerValue
        form.countrySupported = data.countrySupported
        form.outage = data.outage
        form.currencySupported = data.currencySupported
        form.spendLimit = data.spentLimitType
        form.spendLimitValue = data.spendLimit
        form.autoRenew = data.isAutoRenew
        form.duration = data.duration == 0 ? '' : data.duration
        form.durationLimit = data.customDuration
        form.reNewPlan = data.autoRenewPlanId  ? data.autoRenewPlanId :  data.autoRenewPlanId == 0 ? data.autoRenewPlanId :''
        form.displaySupported = data.displaySupported
        form.status = data.status
        getInitialRenewPlanData(data)

        const currentDate = moment(getCurrentDateInTimeZone(targetTimeZone)).toDate();

        if (data.status == "0" || data.status == "1") {
            let givenStartDate = formattedStartDate;
            let givenEndDate = formattedEndDate;
            // let currentDate = moment().format('YYYY-MM-DD')
            if (givenStartDate > currentDate) {
                setIsDisabledStartDate(true)
            }
            if (moment(givenEndDate ? givenEndDate : currentDate).isSameOrAfter(moment(givenStartDate)) && moment(givenEndDate ? givenEndDate : currentDate).isSameOrAfter(moment(currentDate))) {
                setIsDisabledEndDate(true)
            }
        } else {
            setIsDisabledStartDate(true)
            setIsDisabledEndDate(true)
        }


        // if (data.status == "2") {
        if (data.planType == '1') {
            formFields.tenantSupported.required = false;
            formFields.durationLimit.required = false;
            // formFields.duration.required = true;
        } else if (data.planType == '2') {
            formFields.duration.required = false;
        }

        if (data.offerType == "0") {
            formFields.offerValue.required = false
        }
        if (data.isAutoRenew == "0") {
            formFields.reNewPlan.required = false;
        }
        if (data.spentLimitType == "1") {
            formFields.spendLimitValue.required = false;
        }
        // }                                                 


        setCurrentDate(currentDate);

        setEditCaseData(data)

        setForm({ ...form })

    }




    const getTenantList = async () => {

        await dispatch(getTenantAction({ tenantId, authToken, userId, }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    const getTenantList = responseList.filter((ele) => ele.accountType == 0)
                    const setTenantListData = getTenantList.map((data) => {
                        return {
                            id: data.tenantId, value: data.tenantName
                        }
                    })
                    setTenantListOption(setTenantListData)


                    // console.log(responseList, "Tenant List", getTenantList)
                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }


    const getCountryList = async () => {

        await dispatch(getSularCountryListAction({ tenantId, authToken, userId }))
            .then((data) => {
                const {
                    responeCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {

                    const setCountryListData = responseList.map((data) => {
                        return {
                            id: data.id, value: data.countryName
                        }
                    })
                    setCountryListData.unshift({ id: '0', value: 'All' })
                    setCountryListOptions(setCountryListData)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }

    const getInitialRenewPlanData = async (data) => {
        let payload = {}
        if (data.planType == 1) {
            if (data.countrySupported == 0) {
                payload = {
                    planType: data.planType,
                    currencySupported: data.currencySupported,
                    status: 1
                }
            } else {
                payload = {
                    planType: data.planType,
                    countrySupported: data.countrySupported,
                    currencySupported: data.currencySupported,
                    status: 1
                }
            }
        } else {
            if (data.countrySupported == 0) {
                payload = {
                    planType: data.planType,
                    currencySupported: data.currencySupported,
                    tenantSupported: data.tenantSupported,
                    status: 1
                }
            } else {
                payload = {
                    planType: data.planType,
                    countrySupported: data.countrySupported,
                    currencySupported: data.currencySupported,
                    tenantSupported: data.tenantSupported,
                    status: 1
                }
            }

        }

        // const payload = {
        //     planType: +data.planType,
        //     countrySupported: +data.countrySupported,
        //     currencySupported: +data.currencySupported,
        //     tenantSupported: data.tenantSupported == 0 ? null : +data.tenantSupported
        // }

        await dispatch(postListAllSubscriptionPlanMgrAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success") {
                    var getRenewPlanDataFormat = []
                    // console.log(getRenewPlanDataFormat, "@@@@")
                    if (response && response.length > 0) {
                        getRenewPlanDataFormat = response.map((data) => {
                            return {
                                id: data.id, value: data.name
                            }
                        })
                    }

                    getRenewPlanDataFormat.unshift({ id: '0', value: 'Renew Same Plan' })
                    // console.log(getRenewPlanDataFormat, "getRenewPlanDataFormat")
                    setRenewPlanOption(getRenewPlanDataFormat)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }

    const getRenewPlanData = async (currencyValue) => {

        let payload = {}
        if (form.planType == "1") {
            if (form.countrySupported == "0") {
                payload = {
                    planType: +form.planType,
                    currencySupported: +currencyValue,
                    status: 1
                }
            } else {
                payload = {
                    planType: +form.planType,
                    countrySupported: +form.countrySupported,
                    currencySupported: +currencyValue,
                    status: 1
                }
            }
        } else {
            if (form.countrySupported == "0") {
                payload = {
                    planType: +form.planType,
                    // countrySupported: +form.countrySupported,
                    currencySupported: +currencyValue,
                    tenantSupported: +form.tenantSupported,
                    status: 1
                }

            } else {
                payload = {
                    planType: +form.planType,
                    countrySupported: +form.countrySupported,
                    currencySupported: +currencyValue,
                    tenantSupported: form.tenantSupported != 0 ? +form.tenantSupported : null,
                    status: 1

                }
            }

        }

        // const payload = {
        //     planType: +form.planType,
        //     countrySupported: +form.countrySupported,
        //     currencySupported: +form.currencySupported,
        //     tenantSupported: form.tenantSupported != 0 ? +form.tenantSupported : null
        // }

        await dispatch(postListAllSubscriptionPlanMgrAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success") {
                    var getRenewPlanDataFormat = []
                    // console.log(getRenewPlanDataFormat, "@@@@")
                    if (response && response.length > 0) {
                        getRenewPlanDataFormat = response.map((data) => {
                            return {
                                id: data.id, value: data.name
                            }
                        })
                    }

                    getRenewPlanDataFormat.unshift({ id: '0', value: 'Renew Same Plan' })
                    // console.log(getRenewPlanDataFormat, "getRenewPlanDataFormat")
                    setRenewPlanOption(getRenewPlanDataFormat)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }




    const getCurrencyList = async () => {

        await dispatch(getAllCurrencyAction({ tenantId, authToken, userId }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    responseList,
                } = data;
                if (status === "Success" && responseList && responseList.length > 0) {
                    const setCurrencyListData = responseList.map((data) => {
                        return {
                            id: data.key, value: data.value
                        }
                    })
                    setCurrencyListOptions(setCurrencyListData)

                } else {
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }





    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        if (name == "planType") {
            if (value == "1") {
                formFields.tenantSupported.required = false;
                formFields.durationLimit.required = false;
                formFields.duration.required = true;

            } else {
                formFields.tenantSupported.required = true;
                formFields.durationLimit.required = true;
                formFields.duration.required = false;

            }
        }

        if (name == "offer") {
            if (value == "0") {
                newForm.offerValue = ''
                formFields.offerValue.required = false;
                delete formFields.offerValue.min;
                delete formFields.offerValue.max;
                delete formFields.offerValue.minMessage;
                delete formFields.offerValue.maxMessage;
                delete formFields.offerValue.pattern
                delete formFields.offerValue.patternMessage
                setErrors((prevError) => {
                    return {
                        ...prevError,
                        offerValue: {}
                    }
                })

            } else if (value == "1") {
                newForm.offerValue = ''
                formFields.offerValue.min = 1;
                formFields.offerValue.max = 100;
                formFields.offerValue.minMessage = 'Minimum 1 number allowed.';
                formFields.offerValue.maxMessage = 'Maximum 100 number allowed.';
                delete formFields.offerValue.pattern
                delete formFields.offerValue.patternMessage
                formFields.offerValue.required = true;
                setErrors((prevError) => {
                    return {
                        ...prevError,
                        offerValue: {}
                    }
                })

            } else if (value == "2") {
                newForm.offerValue = ''
                delete formFields.offerValue.min;
                delete formFields.offerValue.max;
                delete formFields.offerValue.minMessage;
                delete formFields.offerValue.maxMessage;
                formFields.offerValue.pattern = /^\d{1,100}$/
                formFields.offerValue.patternMessage = 'Please enter only Fix value'
                formFields.offerValue.required = true;
                setErrors((prevError) => {
                    return {
                        ...prevError,
                        offerValue: {}
                    }
                })

            }
            const newTouched = { ...touched };
            const newErrors = { ...errors };
            const { error } = handleFieldError(value, formFields[formFields.offerValue.key]);
            newErrors[e.target.name] = error;
            newTouched[e.target.name] = true;
            setTouched(newTouched);
            setErrors((prevError) => {
                return {
                    ...prevError,
                    ...newErrors
                }
            });
        }

        if (name == "autoRenew") {
            if (value == "0") {
                formFields.reNewPlan.required = false;

            } else {
                formFields.reNewPlan.required = true;

            }
        }

        if (name == "spendLimit") {
            if (value == "1") {
                formFields.spendLimitValue.required = false;
            } else {

                formFields.spendLimitValue.required = true;
            }
        }
        if (name == "currencySupported") {
            getRenewPlanData(value);
        }

        newForm[e.target.name] = value;
        setForm(newForm);
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const showConfirmation = () => {
        let { errors, valid } = handleError(form, formFields);
        if (valid) {
            let confirmationMessage = "Kindly let us know if you'd like to save your changes.";
            toast('confirmation', confirmationMessage);
        }
        setSubmited(true);
        setErrors(errors);
    };

    const handleSubmit = async () => {
        const { match: { params: { id } } } = props;

        // const payload = {
        //     id: id,
        //     name: form.planName,
        //     platformId: 5,
        //     cost: +form.amountCharges,
        //     planType: +form.planType,
        //     displayName: form.planDisplayName,
        //     tenantSupported: +form.tenantSupported,
        //     countrySupported: +form.countrySupported,
        //     currencySupported: +form.currencySupported,
        //     isAutoRenew: +form.autoRenew,
        //     autoRenewPlanId: +form.reNewPlan,
        //     offerType: +form.offer,
        //     offerValue: +form.offerValue,
        //     outage: +form.outage,
        //     spentLimitType: +form.spendLimit,
        //     spendLimit: +form.spendLimitValue,
        //     duration: +form.duration,
        //     customDuration: +form.durationLimit,
        //     displaySupported: +form.displaySupported,
        //     status: +form.status,
        //     startDate: moment(form.startDate).format('YYYY-MM-DD HH:mm:ss'),
        //     endDate: moment(form.endDate).format('YYYY-MM-DD HH:mm:ss'),
        //     description: "description goes here"
        // }

        const payload = {
            id: id,
            name: form.planName,
            platformId: 5,
            cost: +form.amountCharges,
            planType: +form.planType,
            displayName: form.planDisplayName,
            tenantSupported: form.planType == "2" ? +form.tenantSupported : null,
            countrySupported: form.countrySupported  == "0" ? null :  +form.countrySupported,
            currencySupported: +form.currencySupported,
            isAutoRenew: +form.autoRenew,
            autoRenewPlanId: form.autoRenew == "0"  ? null : +form.reNewPlan,
            offerType: +form.offer,
            offerValue: form.offer == "0" ? null : +form.offerValue,
            outage: +form.outage,
            spentLimitType: +form.spendLimit,
            spendLimit: form.spendLimit == "0" ? +form.spendLimitValue : null,
            duration: form.planType == "2" ? null : +form.duration,
            customDuration: form.planType == "2" ? +form.durationLimit : null,
            displaySupported: +form.displaySupported,
            status: +form.status,
            startDate: getUserSelectedDateInUtc({
                date: form.startDate,
                targetTimeZone: targetTimeZone,
                isStartDate: true,
              }),
            endDate: form.endDate == "" ? null : getUserSelectedDateInUtc({
                date: form.endDate,
                targetTimeZone: targetTimeZone,
                isStartDate: false,
              }),
            description: "description goes here"
        }


        await dispatch(postUpdateSubscriptionPlanManagerAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const {
                    responseCode: { status = "", msg = '' },

                } = data;
                if (status === "Success") {
                    toast('Success', msg);
                } else {
                    toast('error', msg);
                    console.log("list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });

    }

    var getPlanStatus = ''

    if (Object.keys(editCaseData).length > 0) {
        getPlanStatus = editCaseData.status

    }


    const openInformationModal = (text = "") => {
        dispatch(reduxDrawerAction({ showDragger: true, data: text }));
      };
    
    
      const infoButtonBooleanData = useMemo(() => {
        let infoObj = {};
        if (Object.keys(subscriptionInfoData).length > 0) {
          Object.keys(subscriptionInfoData).map((data) => {
            if (subscriptionInfoData[data] && subscriptionInfoData[data].length > 0) {
              infoObj[data] = true;
            }
          });
        }
    
        return infoObj;
      }, [subscriptionInfoData]);



    return (

        <>
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    path={`${routes.containers.admin}/${routes.admin.subscriptionPlanMgr.name}`}
                    poc={false}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    outSideClickEnable={false}
                />
            }

            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <BreadCrumb />
                    <div className="row mt-3">
                        <Card>
                            <div className='row'>
                                <div className='col-sm-6'>
                                    <Input
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.planName.key]}
                                        setting={formFields[formFields.planName.key]}
                                        error={errors[formFields.planName.key]}
                                        submited={submited}
                                        touched={touched[formFields.planName.key]}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.planName]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.planName]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <Input
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.planDisplayName.key]}
                                        setting={formFields[formFields.planDisplayName.key]}
                                        error={errors[formFields.planDisplayName.key]}
                                        submited={submited}
                                        touched={touched[formFields.planDisplayName.key]}
                                        infoIcon={infoButtonBooleanData[infoKeys.planDisplayName]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.planDisplayName]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-md-6 mt-3'>
                                    <Datepicker
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.startDate.key] || ''}
                                        setting={formFields[formFields.startDate.key]}
                                        error={errors[formFields.startDate.key]}
                                        submited={submited}
                                        touched={touched[formFields.startDate.key]}
                                        minDate={form[formFields.startDate.key]}
                                        maxDate={form.end == '' ? currentDate : form.endDate}
                                        showDisabledMonthNavigation
                                        disabled={isDisabledStartDate ? false : true}
                                        infoIcon={infoButtonBooleanData[infoKeys.startDate]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.startDate]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-md-6'>
                                    <Datepicker
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.endDate.key] || ''}
                                        setting={formFields[formFields.endDate.key]}
                                        error={errors[formFields.endDate.key]}
                                        submited={submited}
                                        touched={touched[formFields.endDate.key]}
                                        isDisabled={form.startDate ? false : true}
                                        minDate={form.startDate == '' ? currentDate : form.startDate}
                                        // minDate={props.id ? new Date() : form.startDate == '' ? new Date() : form.startDate}
                                        sDate={form.startDate}
                                        disabled={isDisabledEndDate ? false : true}
                                        infoIcon={infoButtonBooleanData[infoKeys.endDate]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.endDate]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.planType.key]}
                                        setting={formFields[formFields.planType.key]}
                                        error={errors[formFields.planType.key]}
                                        submited={submited}
                                        touched={touched[formFields.planType.key]}
                                        options={planTypeOptions}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.planType]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.planType]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <Input
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.amountCharges.key]}
                                        setting={formFields[formFields.amountCharges.key]}
                                        error={errors[formFields.amountCharges.key]}
                                        submited={submited}
                                        touched={touched[formFields.amountCharges.key]}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.amount]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.amount]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.tenantSupported.key]}
                                        setting={formFields[formFields.tenantSupported.key]}
                                        error={errors[formFields.tenantSupported.key]}
                                        submited={submited}
                                        touched={touched[formFields.tenantSupported.key]}
                                        options={tenantListOption}
                                        disabled={form.planType == "1" ? true : false || getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.tenantSupported]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.tenantSupported]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6 d-flex p-0'>
                                    <div className='col-sm-6'>
                                        <SelectNew
                                            onChange={handleChange}
                                            onBlur={handleTouch}
                                            value={form[formFields.offer.key]}
                                            setting={formFields[formFields.offer.key]}
                                            error={errors[formFields.offer.key]}
                                            submited={submited}
                                            touched={touched[formFields.offer.key]}
                                            options={offerOptions}
                                            disabled={getPlanStatus != "2" ? true : false}
                                            infoIcon={infoButtonBooleanData[infoKeys.offer]}
                                            onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.offer]
                                                );
                                            }}
                                        />
                                    </div>
                                    <div className='col-sm-6'>
                                        <Input
                                            onChange={handleChange}
                                            onBlur={handleTouch}
                                            value={form[formFields.offerValue.key]}
                                            setting={formFields[formFields.offerValue.key]}
                                            error={errors[formFields.offerValue.key]}
                                            submited={submited}
                                            touched={touched[formFields.offerValue.key]}
                                            disabled={form.offer == "0" ? true : false || getPlanStatus != "2" ? true : false}
                                            infoIcon={infoButtonBooleanData[infoKeys.offerValue]}
                                            onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.offerValue]
                                                );
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.countrySupported.key]}
                                        setting={formFields[formFields.countrySupported.key]}
                                        error={errors[formFields.countrySupported.key]}
                                        submited={submited}
                                        touched={touched[formFields.countrySupported.key]}
                                        options={countryListOptions}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.countrySupported]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.countrySupported]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <Input
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.outage.key]}
                                        setting={formFields[formFields.outage.key]}
                                        error={errors[formFields.outage.key]}
                                        submited={submited}
                                        touched={touched[formFields.outage.key]}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.outage]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.outage]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.currencySupported.key]}
                                        setting={formFields[formFields.currencySupported.key]}
                                        error={errors[formFields.currencySupported.key]}
                                        submited={submited}
                                        touched={touched[formFields.currencySupported.key]}
                                        options={currencyListOptions}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.currencySupported]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.currencySupported]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6 d-flex p-0'>
                                    <div className='col-sm-6'>
                                        <SelectNew
                                            onChange={handleChange}
                                            onBlur={handleTouch}
                                            value={form[formFields.spendLimit.key]}
                                            setting={formFields[formFields.spendLimit.key]}
                                            error={errors[formFields.spendLimit.key]}
                                            submited={submited}
                                            touched={touched[formFields.spendLimit.key]}
                                            options={spendLimitOptions}
                                            disabled={getPlanStatus != "2" ? true : false}
                                            infoIcon={infoButtonBooleanData[infoKeys.spendLimit]}
                                            onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.spendLimit]
                                                );
                                            }}
                                        />
                                    </div>
                                    <div className='col-sm-6'>
                                        <Input
                                            onChange={handleChange}
                                            onBlur={handleTouch}
                                            value={form[formFields.spendLimitValue.key]}
                                            setting={formFields[formFields.spendLimitValue.key]}
                                            error={errors[formFields.spendLimitValue.key]}
                                            submited={submited}
                                            touched={touched[formFields.spendLimitValue.key]}
                                            disabled={form.spendLimit == 1 ? true : false || getPlanStatus != "2" ? true : false}
                                            infoIcon={infoButtonBooleanData[infoKeys.spendLimitValue]}
                                            onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.spendLimitValue]
                                                );
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.autoRenew.key]}
                                        setting={formFields[formFields.autoRenew.key]}
                                        error={errors[formFields.autoRenew.key]}
                                        submited={submited}
                                        touched={touched[formFields.autoRenew.key]}
                                        options={autoRenewOptions}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.autoRenew]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.autoRenew]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6 d-flex p-0'>
                                    <div className='col-sm-6'>
                                        <SelectNew
                                            onChange={handleChange}
                                            onBlur={handleTouch}
                                            value={form[formFields.duration.key]}
                                            setting={formFields[formFields.duration.key]}
                                            error={errors[formFields.duration.key]}
                                            submited={submited}
                                            touched={touched[formFields.duration.key]}
                                            options={durationOptionsList}
                                            disabled={form.planType == "2" ? true : false || getPlanStatus != "2" ? true : false}
                                            infoIcon={infoButtonBooleanData[infoKeys.duration]}
                                            onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.duration]
                                                );
                                            }}
                                        />
                                    </div>
                                    <div className='col-sm-6'>
                                        <Input
                                            onChange={handleChange}
                                            onBlur={handleTouch}
                                            value={form[formFields.durationLimit.key]}
                                            setting={formFields[formFields.durationLimit.key]}
                                            error={errors[formFields.durationLimit.key]}
                                            submited={submited}
                                            touched={touched[formFields.durationLimit.key]}
                                            disabled={form.planType == "1" ? true : false || getPlanStatus != "2" ? true : false}
                                            infoIcon={infoButtonBooleanData[infoKeys.durationLimitValue]}
                                            onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.durationLimitValue]
                                                );
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.reNewPlan.key]}
                                        setting={formFields[formFields.reNewPlan.key]}
                                        error={errors[formFields.reNewPlan.key]}
                                        submited={submited}
                                        touched={touched[formFields.reNewPlan.key]}
                                        options={renewPlanOption}
                                        disabled={form.autoRenew == '0' ? true : false || getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.renewPlan]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.renewPlan]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.displaySupported.key]}
                                        setting={formFields[formFields.displaySupported.key]}
                                        error={errors[formFields.displaySupported.key]}
                                        submited={submited}
                                        touched={touched[formFields.displaySupported.key]}
                                        options={displaySupportedOptions}
                                        disabled={getPlanStatus != "2" ? true : false}
                                        infoIcon={infoButtonBooleanData[infoKeys.displaySupported]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.displaySupported]
                                                );
                                            }}
                                    />
                                </div>

                                <div className='col-sm-6'>
                                    <SelectNew
                                        onChange={handleChange}
                                        onBlur={handleTouch}
                                        value={form[formFields.status.key]}
                                        setting={formFields[formFields.status.key]}
                                        error={errors[formFields.status.key]}
                                        submited={submited}
                                        touched={touched[formFields.status.key]}
                                        options={getPlanStatus != "2" ? editCasePlanStatusOption : planStatusOptions}
                                        infoIcon={infoButtonBooleanData[infoKeys.status]}
                                        onInfoClick={() => {
                                                openInformationModal(
                                                    subscriptionInfoData[infoKeys.status]
                                                );
                                            }}
                                    // disabled= {form.status != "2" ? true: false}
                                    />
                                </div>
                                {/* end here fields div */}
                            </div>
                            {/* start here save and cancel div */}

                            <div className="col-md-12 py-4 d-flex border justify-content-end" style={{ background: '#F7F8FC', borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                                <button onClick={() => showConfirmation()} className="btn rounded-2" style={{ backgroundColor: '#383890', padding: '0.625rem 1.125rem' }}>
                                    <span className="text-white">Save</span>
                                </button>

                                <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.subscriptionPlanMgr.name}`} className="btn mx-3" style={{ borderRadius: '0.5rem', border: '1px solid #DCE3EE', background: '#FFF', padding: '0.625rem 1.125rem' }}>
                                    <span className="text-primary">Close</span>
                                </Link>
                            </div>

                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
}

export default withRouter(EditSubscriptionPlanMgr)
